import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AdminReports } from '../models/admin.models';
import { ApiResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminReportsService {
  private baseUrl = `${environment.apiBaseUrl}/admin/reports`;

  constructor(private http: HttpClient) {}

  getReports(): Observable<AdminReports> {
    return this.http.get<ApiResponse<AdminReports>>(this.baseUrl).pipe(
      map(res => res.data)
    );
  }
}
